/**
 * 菜单管理 API
 */
import { gapiRequest } from './request'

export interface MenuTreeNode {
  id: number
  pid: number
  menu_type: string
  menu_name: string
  title: string
  title_en: string
  url: string
  file_path: string
  remark: string
  sort: number
  is_show: number
  create_time: string | null
  update_time: string | null
  child: MenuTreeNode[]
}

export interface MenuTreeResponse {
  menus: MenuTreeNode[]
  menu_type: string
  group_id?: number | null
}

export const menuApi = {
  // 获取当前用户的菜单(已迁移至 Go)
  getMe: () =>
    gapiRequest.get<any, MenuTreeResponse>('/v1/menu/me'),

  // 获取所有菜单树
  getTree: (menu_type: string = 'pms_system') =>
    gapiRequest.get<any, MenuTreeResponse>('/v1/menu/tree', {
      params: { menu_type }
    }),
}
